import { AxiosRequestConfig, AxiosRequestHeaders, ResponseType } from 'axios';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { DEFAULT_HEADERS, httpClient } from 'services/_https-client';

export interface IServiceConfig {
  controller: Controller;
  headers?: AxiosRequestHeaders;
}

interface IAxiosRequest {
  uri?: string;
  params?: AxiosRequestConfig;
  headers?: AxiosRequestHeaders;
  responseType?: ResponseType;
}

export interface IGenericResponse {
  message: string;
  error?: any;
}

// todo: maybe we should convert this to a generic and cleanup some of the return types
export class BaseRESTService {
  constructor(private config: IServiceConfig) {}

  async get(request: IAxiosRequest = {}): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ''}`;

      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .get(url, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async delete(request: IAxiosRequest = {}): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ''}`;

      const config = {
        params: {
          ...request.params,
        },
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .delete(url, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async post(
    request: IAxiosRequest = {},
    data: any,
    onProgress?: (event: ProgressEvent) => void
  ): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ''}`;
      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
        responseType: request.responseType ?? undefined,
        onUploadProgress: (ev: ProgressEvent) => {
          if (onProgress) {
            onProgress(ev);
          }
        },
      };

      return httpClient
        .post(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async put(request: IAxiosRequest = {}, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ''}`;
      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .put(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async patch(request: IAxiosRequest = {}, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ''}`;
      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .patch(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }
}
